import axios from 'axios';
import { postData } from '../../../services/axiosUtils';

const asList = (data: any) => {
  if (Array.isArray(data)) {
    return { hasError: false, records: data, errorMessages: [] };
  }
  if (data?.records) return data;
  return { hasError: false, records: data ? [data] : [], errorMessages: [] };
};

const wrap = (data: any) => {
  if (data?.hasError !== undefined) return data;
  return { hasError: false, result: data, errorMessages: [] };
};

const platformRoleService = {
  list: () =>
    axios.get('/api/platform-roles').then((r) => asList(r.data)),
  get: (id: string) =>
    axios.get(`/api/platform-roles/${id}`).then((r) => wrap(r.data)),
  create: (entity: { name: string; description?: string }) =>
    postData({ url: '/api/platform-roles', data: entity }).then(wrap),
  update: (id: string, entity: { name: string; description?: string }) =>
    postData({
      url: `/api/platform-roles/${id}`,
      data: entity,
      method: 'PUT',
    }).then(wrap),
  setPermissions: (id: string, permissions: string[]) =>
    postData({
      url: `/api/platform-roles/${id}/permissions`,
      data: permissions,
      method: 'PUT',
    }).then(wrap),
  delete: (id: string) =>
    postData({
      url: `/api/platform-roles/${id}`,
      method: 'DELETE',
    }).then(wrap),
};

export default platformRoleService;
